import {noop, template} from "lodash";
import {
    Add_Map,
    Batch_Search,
    Batch_Sync_Status,
    Cargo_Owner_Info,
    Change_Customer_Active,
    Change_Order_Status,
    Check_Product_Sku,
    Choice_Owner,
    Create_Kit,
    Create_Product,
    Dict_Type,
    Download_Product_Template,
    Ecommerce_Information,
    ECShop_Basic_Info,
    Edit_Kit,
    Edit_Map,
    Edit_Product,
    Export_Aging,
    Export_Inventory_Batch,
    Export_Inventory_Product,
    Filter_Customer,
    Filter_Map,
    Filter_Owner,
    Filter_Packaging,
    Kit_Detail,
    Map_Info,
    Modify_Kit_Status,
    Modify_SKU_Status,
    Online_Check_ECShop,
    Online_Shop_Add, Online_Shop_Create, Online_Shop_Edit,
    Online_Shop_Info,
    Online_Shop_List,
    Online_Shop_Platform_Params,
    Owner_List,


} from "../../config";
import api from "../../api/api";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";


export const IntegrationActionType = {
    ONLINE_SHOP_BASIC_LIST:"ONLINE_SHOP_BASIC_LIST",
    ONLINE_SHOP_SEARCH_LIST:"ONLINE_SHOP_SEARCH_LIST",
    OWNERS_LIST:'OWNERS_LIST',
    ONLINE_SHOP_DEFAULT_PARAMS:'ONLINE_SHOP_DEFAULT_PARAMS'
}


export const onlineShopFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineList)) return null;
        const url = `${Online_Shop_List}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:IntegrationActionType.ONLINE_SHOP_SEARCH_LIST,
            //     payload:response.data?.data
            // })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const getOnlineShopBasicInfo = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineBasicInfo)) return null;
        const url = `${ECShop_Basic_Info}`
        //const response = await api.get(url,{params: {...data}})
        const response = await api.get(url)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:IntegrationActionType.ONLINE_SHOP_BASIC_LIST,
                payload:response?.data?.data
            })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const getListOwnerInfo = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineOwnerInfo)) return null;
        const url = `${Owner_List}`
        //const response = await api.get(url,{params: {...data}})
        const response = await api.get(url)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:IntegrationActionType.OWNERS_LIST,
            //     payload:response?.data?.data?.ownerInfoList
            // })
            onSuccess(response.data?.data?.ownerInfoList)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const onlineShopInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineInfo)) return null;

        const url = `${Online_Shop_Info}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data?.onlineShopEntity)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const getOnlineShopFlatformParams = (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineApiParam)) return null;
        const url = `${Online_Shop_Platform_Params}`
        const response = await api.get(url,{params: {...data}})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            let array = [];
            for (let i = 1; i <= 10; i++) {
                let obj = {
                    id: i,
                    [`apiParamsValue`]: response?.data?.data[`apiParamsDefaultValue${i}`],
                    [`apiParamsKey`]: response?.data?.data[`apiParamsKey${i}`]
                };
                array.push(obj);
            }
            dispatch({
                type:IntegrationActionType.ONLINE_SHOP_DEFAULT_PARAMS,
                payload:[...array]
            })
            onSuccess([...array])
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const check_ecshop_id = (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineEcShopId)) return null;
        const url = `${Online_Check_ECShop}`
        const response = await api.get(url,{params: {...data}})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data?.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const addOnlineShop  = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineSaveUpdate)) return null;
        const url = `${Online_Shop_Add}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess('Save Online Shop Information Successfully')
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const createOnlineShop  = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineAdd)) return null;
        const url = `${Online_Shop_Create}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess('Save Online Shop Information Successfully')
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const editOnlineShop  = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.IntegrationOnlineModify)) return null;
        const url = `${Online_Shop_Edit}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess('Save Online Shop Information Successfully')
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}










